// admin/src/Component/CookieConsent/List.js
import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    BooleanField,
    NumberField,
    Filter,
    TextInput,
    ReferenceField,
    Pagination
} from 'react-admin';

import DownloadGTMTag from './DownloadGTMTag';
import CloneCookieConsent from "./CloneCookieConsent";
import LocalUrlField from "../CookieConsentScan/LocalUrlField";

const ConsentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search name" source="name" alwaysOn options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
        <TextInput label="Search url" source="url" options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
        <TextInput label="Search ID" source="id" options={{
            autoComplete: 'off',
            inputProps: { 'data-lpignore': 'true' },
        }} />
    </Filter>
);

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500]} {...props} />;

export const CookieConsentList = (props) => (
    <List filters={<ConsentFilter />} {...props} title="Cookie consent" perPage={100} pagination={<PostPagination/>} sort={{ field: 'updateDate' , order: 'DESC' }}>
        <Datagrid>

            <BooleanField source="active" label="Active" />
            <NumberField source="number_of_scanned_pages" sortBy="numberOfScannedPages" label="Pages" />
            <TextField source="name" label="Name" />

            <ReferenceField label="Template" source="cookie_consent_template" reference="cookie-consent-templates">
                <TextField source="name" />
            </ReferenceField>

            <LocalUrlField source="url" label="URL" />
            <DateField source="update_date" sortBy="updateDate" showTime locales="nl-NL"  />
            <EditButton />
            <CloneCookieConsent />
            <DownloadGTMTag />

        </Datagrid>
    </List>
);